import React from "react";
import QuotationSelectContainer from "./quotation-selected.container";

const QuotationSelected = () => {
  return <QuotationSelectContainer />;
};

export default QuotationSelected;
